import React from "react";

import LogoMeridiam from "./symbols/LogoMeridiam/LogoMeridiam";
import "./styles.scss";

const SpriteSvg = () => {
  return (
    <svg
      className="defs-svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <LogoMeridiam />

        <symbol viewBox="0 0 110 110">
          <path
            d="M55 27c-11.316 0-18.667 10.069-18.667 18.779a24.683 24.683 0 003.557 12.546l12.772 23.286a2.662 2.662 0 004.675 0L70.11 58.325a24.682 24.682 0 003.557-12.546C73.667 37.069 66.315 27 55 27zm0 31.829a13.049 13.049 0 1112.963-13.05A13.006 13.006 0 0155 58.829z"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
          />
          <g fill="currentColor">
            <path d="M54.5 36.44a8.581 8.581 0 00-1.91.3l1.11 3.434a5.724 5.724 0 01.8-.127zM52.038 40.852a5.727 5.727 0 01.716-.368l-1.115-3.433a8.556 8.556 0 00-1.724.878zM49.246 45.78a5.774 5.774 0 011.983-4.339l-2.124-2.923a8.789 8.789 0 00-1.671 1.766 9.364 9.364 0 001.672 12.758l1.183-1.628.94-1.294a5.774 5.774 0 01-1.983-4.34z" />
            <path d="M60.754 45.78A5.761 5.761 0 0155 51.534a5.694 5.694 0 01-2.962-.826l-2.123 2.922A8.883 8.883 0 0055 55.131a9.352 9.352 0 00.5-18.69v3.605a5.763 5.763 0 015.254 5.734z" />
          </g>
        </symbol>

        <symbol id="icon-environment" viewBox="0 0 60 47">
          <g
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
          >
            <path d="M5.177 23.5h46.5M28.427.25v46.5M51.337 27.445A23.234 23.234 0 0028.427.25M47.033 37.442a23.214 23.214 0 01-18.606 9.308M16.182 3.737A23.135 23.135 0 0128.427.25M7.347 13.691a23.25 23.25 0 0021.08 33.059" />
            <path d="M28.427 46.75c8.126 0 14.713-10.409 14.713-23.25S36.553.25 28.427.25M18.73 6.022C21.32 2.431 24.711.25 28.427.25M15.087 13.691a34.8 34.8 0 00-1.373 9.809c0 12.841 6.587 23.25 14.713 23.25" />
          </g>
          <g fill="currentColor">
            <path d="M22.092 10.467h-1.166v-.5a2.824 2.824 0 00-3.982-2.582l-.658.292-.044-.718A5.5 5.5 0 005.481 5.767l-.158.542-.523-.222A3.5 3.5 0 103.426 12.8h18.666a1.165 1.165 0 100-2.331zM57.426 31.3a2.493 2.493 0 00-.985.2l-.519.222-.158-.541a4 4 0 00-7.825.867l-.044.718-.658-.292a1.993 1.993 0 00-2.811 1.826v.5h-1a.749.749 0 100 1.5h14a2.5 2.5 0 100-4.995z" />
          </g>
        </symbol>

        <symbol id="icon-governance" viewBox="0 0 76 54">
          <g fill="none" stroke="currentColor" strokeMiterlimit="10">
            <path
              strokeWidth=".5"
              d="M54 29.664v-5.328A1.344 1.344 0 0052.793 23l-3.508-.36a1.347 1.347 0 01-1.16-1.023 21.535 21.535 0 00-2.347-5.654 1.346 1.346 0 01.1-1.545l2.222-2.739a1.344 1.344 0 00-.092-1.8l-3.763-3.766a1.344 1.344 0 00-1.8-.092L39.708 8.25a1.346 1.346 0 01-1.545.1A21.526 21.526 0 0032.509 6a1.347 1.347 0 01-1.024-1.16l-.36-3.508A1.344 1.344 0 0029.789.125h-5.328a1.344 1.344 0 00-1.337 1.207l-.36 3.508A1.347 1.347 0 0121.741 6a21.525 21.525 0 00-5.654 2.347 1.346 1.346 0 01-1.545-.1L11.8 6.021a1.344 1.344 0 00-1.8.092L6.238 9.88a1.344 1.344 0 00-.092 1.8l2.229 2.738a1.346 1.346 0 01.1 1.545 21.534 21.534 0 00-2.347 5.654 1.347 1.347 0 01-1.16 1.023L1.457 23A1.344 1.344 0 00.25 24.336v5.328A1.344 1.344 0 001.457 31l3.508.36a1.347 1.347 0 011.16 1.023 21.537 21.537 0 002.347 5.654 1.346 1.346 0 01-.1 1.545l-2.226 2.739a1.344 1.344 0 00.092 1.8l3.768 3.767a1.344 1.344 0 001.8.092l2.738-2.229a1.346 1.346 0 011.545-.1A21.539 21.539 0 0021.741 48a1.347 1.347 0 011.023 1.16l.36 3.508a1.344 1.344 0 001.337 1.207h5.328a1.344 1.344 0 001.337-1.207l.36-3.508A1.347 1.347 0 0132.509 48a21.539 21.539 0 005.654-2.347 1.346 1.346 0 011.545.1l2.738 2.229a1.344 1.344 0 001.8-.092l3.768-3.767a1.344 1.344 0 00.092-1.8l-2.229-2.738a1.346 1.346 0 01-.1-1.545 21.537 21.537 0 002.347-5.654 1.347 1.347 0 011.16-1.024L52.793 31A1.344 1.344 0 0054 29.664zM27.125 44a17 17 0 1117-17 17 17 0 01-17 17z"
            />
            <circle cx="27.125" cy="27" r="13" />
            <ellipse cx="27.125" cy="27" rx="8.227" ry="13" />
            <path d="M14.125 27h26M27.125 14v26" />
          </g>
          <path
            fill="currentColor"
            d="M75.1 39.5a1.7 1.7 0 00.763-2.147l-.235-.567a1.7 1.7 0 00-2.057-.978 1.686 1.686 0 01-1.768-.522 10.227 10.227 0 00-1.176-1.174 1.687 1.687 0 01-.526-1.772v-.005a1.7 1.7 0 00-.978-2.058l-.568-.235a1.7 1.7 0 00-2.146.763 1.687 1.687 0 01-1.625.881 10.241 10.241 0 00-1.662 0 1.686 1.686 0 01-1.619-.881 1.7 1.7 0 00-2.146-.763l-.568.235a1.7 1.7 0 00-.978 2.058 1.686 1.686 0 01-.522 1.768 10.217 10.217 0 00-1.174 1.176 1.687 1.687 0 01-1.772.526 1.7 1.7 0 00-2.058.978l-.235.567a1.7 1.7 0 00.763 2.147h.005a1.687 1.687 0 01.881 1.625 10.227 10.227 0 000 1.661 1.686 1.686 0 01-.881 1.62 1.7 1.7 0 00-.763 2.147l.235.568a1.7 1.7 0 002.057.978 1.686 1.686 0 011.768.522 10.227 10.227 0 001.17 1.182 1.687 1.687 0 01.526 1.772 1.7 1.7 0 00.978 2.058l.568.235a1.7 1.7 0 002.147-.763 1.687 1.687 0 011.625-.881 10.23 10.23 0 001.661 0 1.686 1.686 0 011.62.881 1.7 1.7 0 002.147.763l.568-.235a1.7 1.7 0 00.978-2.058 1.686 1.686 0 01.522-1.768A10.236 10.236 0 0071.8 48.63a1.687 1.687 0 011.772-.526h.006a1.7 1.7 0 002.057-.978l.235-.568a1.7 1.7 0 00-.763-2.147 1.687 1.687 0 01-.881-1.625 10.228 10.228 0 000-1.661A1.686 1.686 0 0175.1 39.5zm-11.143 8.458a6 6 0 116-6 6 6 0 01-6 6z"
          />
        </symbol>

        {/* <symbol id="icon-country-data" viewBox="0 0 37 56">
          <g fill="currentColor">
            <path d="M18.5.5c10.608 0 18 9.633 18 18.279a24.352 24.352 0 01-3.464 12.307L20.377 54.372a2.127 2.127 0 01-3.755 0L3.961 31.08A24.344 24.344 0 01.5 18.779C.5 10.133 7.892.5 18.5.5m0 31.78A13.5 13.5 0 105 18.779a13.516 13.516 0 0013.5 13.5M18.5 0C7.286 0 0 10.069 0 18.779a24.849 24.849 0 003.525 12.546l12.658 23.286a2.627 2.627 0 004.634 0l12.658-23.286A24.848 24.848 0 0037 18.779C37 10.069 29.714 0 18.5 0zm0 31.78a13 13 0 1113-13 13 13 0 01-13 13z" />
            <path d="M18 9.44a8.581 8.581 0 00-1.91.3l1.11 3.434a5.724 5.724 0 01.8-.127zM15.538 13.852a5.727 5.727 0 01.716-.368l-1.115-3.433a8.556 8.556 0 00-1.724.878zM12.746 18.78a5.774 5.774 0 011.983-4.339l-2.124-2.923a8.789 8.789 0 00-1.671 1.766 9.364 9.364 0 001.672 12.758l1.183-1.628.94-1.294a5.774 5.774 0 01-1.983-4.34z" />
            <path d="M24.254 18.78a5.761 5.761 0 01-5.754 5.754 5.694 5.694 0 01-2.962-.826l-2.123 2.922a8.883 8.883 0 005.085 1.5A9.352 9.352 0 0019 9.441v3.605a5.763 5.763 0 015.254 5.734z" />
          </g>
        </symbol> */}

        <symbol id="icon-social" viewBox="0 0 61 80">
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
            d="M15.251 9.525l15-8.775 15 8.775v17.55l-15 8.775-15-8.775V9.525z"
          />
          <path
            fill="currentColor"
            d="M36.75 16.222h-4.5v-4.513h-4v4.513h-4.5v4.012h4.5v4.512h4v-4.512h4.5v-4.012z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
            d="M30.251 35.876l15-8.775 15 8.775v17.549l-15 8.775-15-8.775V35.876z"
          />
          <path
            fill="currentColor"
            d="M40.21 44.045l5.041 2.535 5.041-2.535v2.535s-.925 2.808-5.041 2.808-5.041-2.808-5.041-2.808zM50.922 51.707a1.12 1.12 0 10-2.24 0"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
            d="M45.251 37.594l-8.961 4.493 8.961 4.493 8.961-4.493-8.961-4.493z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            d="M45.25 42.087l4.552 2.211v7.409"
          />
          <ellipse
            cx="45.25"
            cy="42.087"
            rx="1.12"
            ry=".562"
            fill="currentColor"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
            d="M.25 53.425l15-8.775 15 8.775v17.55l-15 8.775-15-8.775v-17.55z"
          />
          <g fill="currentColor">
            <path d="M20.631 53.97v12.981H11.05a.5.5 0 00-.5.5v.684h-.68v-12.98a1.184 1.184 0 011.18-1.185h9.581m.5-.5H11.05a1.683 1.683 0 00-1.68 1.685v13.48h1.68v-1.184h10.081V53.47z" />
            <path d="M11.05 68.042v-.5h10.081v-.592H11.05a1.685 1.685 0 000 3.37h10.081v-.592H11.05v-.5h10.081v-.341H11.05v-.5h10.081v-.342zM18.89 57.963l-1.12-1.123-1.12 1.123V53.47h2.24v4.493z" />
          </g>
        </symbol>

        <symbol id="icon-societal" viewBox="0 0 59 65">
          <g fill="currentColor">
            <path d="M30.464 0H12.182A4.481 4.481 0 007.7 4.481V10.8a4.481 4.481 0 004.481 4.481h2.24v4.381L18.8 15.28h2.9v-3.8A5.487 5.487 0 0127.182 6h7.762V4.481A4.481 4.481 0 0030.464 0z" />
            <path d="M45.464 7H27.182a4.48 4.48 0 00-4.48 4.48v6.32a4.48 4.48 0 004.48 4.48h11.661l4.381 4.381V22.28h2.24a4.481 4.481 0 004.481-4.48v-6.32A4.481 4.481 0 0045.464 7z" />
          </g>
          <g
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
          >
            <path d="M.25 62.319a2.431 2.431 0 114.862 0" />
            <circle cx="13.863" cy="35.58" r="6.589" />
            <path d="M22.614 55.027v7.293a2.431 2.431 0 002.431 2.431h0a2.431 2.431 0 002.431-2.431V50.165a5.834 5.834 0 00-5.834-5.834H6.084A5.834 5.834 0 00.25 50.165v12.154a2.431 2.431 0 004.862 0v-7.292M22.614 62.319a2.431 2.431 0 114.862 0" />
            <g>
              <path d="M31.524 62.319a2.431 2.431 0 114.862 0" />
              <circle cx="45.137" cy="35.58" r="6.589" />
              <path d="M53.888 55.027v7.293a2.431 2.431 0 002.431 2.431h0a2.431 2.431 0 002.431-2.431V50.165a5.834 5.834 0 00-5.834-5.834H37.359a5.834 5.834 0 00-5.834 5.834v12.154a2.431 2.431 0 004.862 0v-7.292M53.888 62.319a2.431 2.431 0 114.862 0" />
            </g>
          </g>
        </symbol>

        <symbol id="icon-project-information-and-activity" viewBox="0 0 47 61">
          <path
            fill="currentColor"
            d="M23.509.5a3.691 3.691 0 013.7 3.678v.5h16.8a2.5 2.5 0 012.5 2.5V58a2.5 2.5 0 01-2.5 2.5h-41a2.5 2.5 0 01-2.5-2.5V7.178a2.5 2.5 0 012.5-2.5h16.8v-.5A3.691 3.691 0 0123.509.5m0-.5a4.187 4.187 0 00-4.2 4.178h-16.3a3 3 0 00-3 3V58a3 3 0 003 3h41a3 3 0 003-3V7.178a3 3 0 00-3-3H27.7A4.187 4.187 0 0023.509 0z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth=".5"
            d="M5.042 9.106h36.915v46.983H5.042z"
          />
          <path
            fill="currentColor"
            d="M23.5 2.964a.863.863 0 11-.863.863.864.864 0 01.863-.863m0-.5a1.363 1.363 0 101.363 1.363A1.363 1.363 0 0023.5 2.464z"
          />
          <g>
            <path
              fill="currentColor"
              d="M10.184 13.905H30.32v3.356H10.184zM10.184 19.778h22.652v1.678H10.184zM10.184 22.294h25.169v1.678H10.184zM10.184 24.811H30.32v1.678H10.184z"
            />
            <path
              fill="none"
              stroke="currentColor"
              strokeMiterlimit="10"
              d="M10.707 37.24l6.292 1.678 6.293-5.034 6.292 2.517 6.292-5.872"
            />
            <path
              fill="none"
              stroke="currentColor"
              strokeMiterlimit="10"
              d="M10.707 39.757l6.292-5.532 6.293 3.854 6.292.839 6.292-3.575"
            />
            <path
              fill="currentColor"
              d="M10.183 41.67H12.7v6.712h-2.517zM14.045 45.341h2.517v3.041h-2.517zM17.908 46.232h2.517v2.15h-2.517zM21.771 43.978h2.517v4.405h-2.517zM25.634 42.981h2.517v5.401h-2.517zM29.497 46.18h2.517v2.202h-2.517zM33.359 47.281h2.517v1.101h-2.517z"
            />
          </g>
        </symbol>

        <symbol viewBox="0 0 92 120">
          <path
            fill="currentColor"
            d="M46 .5c4.3 0 7.7 3.5 7.7 7.7v.5h30.1c4.3 0 7.7 3.5 7.7 7.7v95.3c0 4.3-3.5 7.7-7.7 7.7H8.2c-4.3 0-7.7-3.5-7.7-7.7V16.4c0-4.3 3.5-7.7 7.7-7.7h30.1v-.5C38.3 4 41.7.5 46 .5m0-.5c-4.5 0-8.2 3.7-8.2 8.2H8.2C3.7 8.2 0 11.9 0 16.4v95.3c0 4.5 3.7 8.2 8.2 8.2h75.6c4.5 0 8.2-3.7 8.2-8.2V16.4c0-4.5-3.7-8.2-8.2-8.2H54.2C54.2 3.7 50.5 0 46 0z"
          />
          <path
            fill="currentColor"
            d="M81.5 18.6v91h-71v-91h71m.5-.5H10v92h72v-92zM46 5.6c1.2 0 2.2 1 2.2 2.2S47.2 10 46 10c-1.2 0-2.2-1-2.2-2.2 0-1.3 1-2.2 2.2-2.2m0-.5c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7c1.5 0 2.7-1.2 2.7-2.7 0-1.5-1.2-2.7-2.7-2.7z"
          />
          <path
            fill="currentColor"
            d="M30.4 39.1v.4c0 .3-.3.6-.6.6.1 1.9-1 3.7-2.8 4.5 1.8.8 2.9 2.6 2.8 4.5.3 0 .6.3.6.6v.3c0 .3-.3.6-.6.6H22c-.3 0-.6-.3-.6-.6v-.4c0-.3.3-.6.6-.6-.1-1.9 1-3.7 2.8-4.5C23 43.8 21.9 42 22 40c-.3 0-.6-.3-.6-.6V39c0-.3.3-.6.6-.6h7.9c.2.1.5.4.5.7zm-2.1.9h-4.9c0 .5.1 1 .3 1.5h4.4c.2-.4.2-.9.2-1.5zm-2.4 5.7c-1 .1-1.9.9-2.2 1.9h4.4c-.3-1.1-1.2-1.8-2.2-1.9zM45.9 50.4c-3.2 0-5.8-2.6-5.8-5.8s2.6-5.8 5.8-5.8 5.8 2.6 5.8 5.8c0 3.2-2.6 5.8-5.8 5.8zm3.6-7.1c.1-.1.1-.4 0-.5l-.5-.6c-.1-.1-.4-.1-.5 0L45 45.8l-1.6-1.6c-.1-.1-.4-.1-.5 0l-.5.5c-.1.1-.1.4 0 .5l2.4 2.4c.1.1.4.1.5 0l4.2-4.3zM25.9 70.4c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c0 3.2-2.6 5.8-5.8 5.8zm-1.1-3.6c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1zm.3-1.8c0 .1.1.3.3.3h1.1c.1 0 .3-.1.3-.3l.2-3.2c0-.2-.1-.3-.3-.3h-1.5c-.2 0-.3.1-.3.3l.2 3.2zM65.9 70.4c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8zm3.6-7.1c.1-.1.1-.4 0-.5l-.5-.6c-.1-.1-.4-.1-.5 0L65 65.8l-1.6-1.6c-.1-.1-.4-.1-.5 0l-.5.5c-.1.1-.1.4 0 .5l2.4 2.4c.1.1.4.1.5 0l4.2-4.3zM50.4 59.1v.4c0 .3-.3.6-.6.6.1 1.9-1 3.7-2.8 4.5 1.8.8 2.9 2.6 2.8 4.5.3 0 .6.3.6.6v.3c0 .3-.3.6-.6.6H42c-.3 0-.6-.3-.6-.6v-.4c0-.3.3-.6.6-.6-.1-1.9 1-3.7 2.8-4.5C43 63.8 41.9 62 42 60c-.3 0-.6-.3-.6-.6V59c0-.3.3-.6.6-.6h7.9c.2.1.5.4.5.7zm-4.5 6.6c-1.4 0-2.4 1.6-2.4 3.4h4.9c-.1-1.9-1.1-3.4-2.5-3.4zM67 44.5c1.8.8 2.9 2.6 2.8 4.5.3 0 .6.3.6.6v.4c0 .3-.3.6-.6.6H62c-.3 0-.6-.3-.6-.6v-.4c0-.3.3-.6.6-.6-.1-1.9 1-3.7 2.8-4.5C63 43.8 61.9 42 62 40c-.3 0-.6-.3-.6-.6V39c0-.3.3-.6.6-.6h7.9c.3 0 .6.3.6.6v.4c0 .3-.3.6-.6.6 0 2-1.1 3.8-2.9 4.5zm1.3-4.5h-4.9c0 1.8 1.1 3.4 2.4 3.4s2.5-1.5 2.5-3.4zM27 84.5c1.8.8 2.9 2.6 2.8 4.5.3 0 .6.3.6.6v.4c0 .3-.3.6-.6.6H22c-.3 0-.6-.3-.6-.6v-.4c0-.3.3-.6.6-.6-.1-1.9 1-3.7 2.8-4.5C23 83.8 21.9 82 22 80c-.3 0-.6-.3-.6-.6V79c0-.3.3-.6.6-.6h7.9c.3 0 .6.3.6.6v.4c0 .3-.3.6-.6.6 0 2-1.1 3.8-2.9 4.5zm1.3-4.5h-4.9c0 1.8 1.1 3.4 2.4 3.4s2.5-1.5 2.5-3.4zM45.9 90.4c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c0 3.2-2.6 5.8-5.8 5.8zm3.6-7.1c.1-.1.1-.4 0-.5l-.5-.6c-.1-.1-.4-.1-.5 0L45 85.8l-1.6-1.6c-.1-.1-.4-.1-.5 0l-.5.5c-.1.1-.1.4 0 .5l2.4 2.4c.1.1.4.1.5 0l4.2-4.3zM61 87.6c-1.7-2.7-.9-6.3 1.9-8s6.3-.9 8 1.9.9 6.3-1.9 8c-.9.6-2 .9-3.1.9-2 0-3.9-1.1-4.9-2.8m3.8-.8c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1m.3-1.8c0 .1.1.3.3.3h1.1c.1 0 .3-.1.3-.3l.2-3.2c0-.2-.1-.3-.3-.3h-1.5c-.2 0-.3.1-.3.3l.2 3.2z"
          />
        </symbol>

        <symbol id="icon-loader-save-btn" viewBox="0 0 16 16">
          <circle fill="currentColor" cx="14.5" cy="8" r="1.5" />
          <circle fill="currentColor" cx="12.6" cy="12.6" r="1.5" />
          <circle fill="currentColor" cx="8" cy="14.5" r="1.5" />
          <circle fill="currentColor" cx="3.4" cy="12.6" r="1.5" />
          <circle fill="currentColor" cx="1.5" cy="8" r="1.5" />
          <circle fill="currentColor" cx="3.4" cy="3.4" r="1.5" />
          <circle fill="currentColor" cx="8" cy="1.5" r="1.5" />
        </symbol>

        <symbol id="icon-esg-sdg-survey-management" viewBox="0 0 92 120">
          <g>
            <g>
              <path
                fill="currentColor"
                d="M46,.5a7.728,7.728,0,0,1,7.719,7.719v.5H83.808a7.728,7.728,0,0,1,7.719,7.719v95.342a7.728,7.728,0,0,1-7.719,7.719H8.192a7.728,7.728,0,0,1-7.719-7.719V16.438A7.728,7.728,0,0,1,8.192,8.719H38.281v-.5A7.728,7.728,0,0,1,46,.5M46,0a8.219,8.219,0,0,0-8.219,8.219H8.192A8.219,8.219,0,0,0-.027,16.438v95.342A8.219,8.219,0,0,0,8.192,120H83.808a8.219,8.219,0,0,0,8.219-8.219V16.438a8.219,8.219,0,0,0-8.219-8.219H54.219A8.219,8.219,0,0,0,46,0Z"
              />
              <path
                fill="currentColor"
                d="M81.5,18.61v91h-71v-91h71m.5-.5H10v92H82v-92Z"
              />
              <path
                fill="currentColor"
                d="M46,5.568A2.171,2.171,0,1,1,43.829,7.74,2.174,2.174,0,0,1,46,5.568m0-.5A2.671,2.671,0,1,0,48.671,7.74,2.671,2.671,0,0,0,46,5.068Z"
              />
            </g>
            <g>
              <path
                d="M30.4,39.105v.375a.563.563,0,0,1-.562.563,4.65,4.65,0,0,1-2.832,4.5,4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H21.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H29.84A.563.563,0,0,1,30.4,39.105Z"
                fill="#ffe136"
              />
              <path
                d="M28.34,40.043H23.465a4.4,4.4,0,0,0,.26,1.5h4.356A4.412,4.412,0,0,0,28.34,40.043Z"
                fill="#102d40"
              />
              <path
                d="M25.9,45.668a2.517,2.517,0,0,0-2.178,1.875H28.08A2.517,2.517,0,0,0,25.9,45.668Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="45.903" cy="44.543" r="5.813" fill="#1ad49b" />
              <path
                d="M49.543,43.308a.377.377,0,0,0,0-.53l-.531-.53a.375.375,0,0,0-.53,0l-3.517,3.517-1.642-1.642a.375.375,0,0,0-.53,0l-.531.53a.377.377,0,0,0,0,.53L44.7,47.621a.376.376,0,0,0,.531,0Z"
                fill="#102d40"
              />
            </g>
            <g>
              <path
                fill="#389ad6"
                d="M67.008,44.543a4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H61.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H69.84a.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563A4.65,4.65,0,0,1,67.008,44.543Z"
              />
              <path
                d="M68.34,40.043H63.465c0,1.816,1.083,3.375,2.437,3.375S68.34,41.87,68.34,40.043Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="25.903" cy="64.543" r="5.813" fill="#ff4a56" />
              <circle cx="25.903" cy="66.793" r="1.078" fill="#102d40" />
              <path
                d="M25.053,65.027a.28.28,0,0,0,.28.266h1.139a.28.28,0,0,0,.28-.266l.174-3.187a.281.281,0,0,0-.28-.3H25.159a.281.281,0,0,0-.28.3Z"
                fill="#102d40"
              />
            </g>
            <g>
              <path
                d="M50.4,59.105v.375a.563.563,0,0,1-.562.563,4.65,4.65,0,0,1-2.832,4.5,4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H41.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H49.84A.563.563,0,0,1,50.4,59.105Z"
                fill="#ffe136"
              />
              <path
                d="M45.9,65.668c-1.354,0-2.437,1.56-2.437,3.375H48.34C48.34,67.227,47.257,65.668,45.9,65.668Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="65.903" cy="64.543" r="5.813" fill="#1ad49b" />
              <path
                d="M69.543,63.308a.377.377,0,0,0,0-.53l-.531-.53a.375.375,0,0,0-.53,0l-3.517,3.517-1.642-1.642a.375.375,0,0,0-.53,0l-.531.53a.377.377,0,0,0,0,.53L64.7,67.621a.376.376,0,0,0,.531,0Z"
                fill="#102d40"
              />
            </g>
            <g>
              <path
                d="M27.008,84.543a4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H21.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H29.84a.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563A4.65,4.65,0,0,1,27.008,84.543Z"
                fill="#389ad6"
              />
              <path
                d="M28.34,80.043H23.465c0,1.816,1.083,3.375,2.438,3.375S28.34,81.87,28.34,80.043Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="45.903" cy="84.543" r="5.813" fill="#1ad49b" />
              <path
                d="M49.543,83.308a.377.377,0,0,0,0-.53l-.531-.53a.375.375,0,0,0-.53,0l-3.517,3.517-1.642-1.642a.375.375,0,0,0-.53,0l-.531.53a.377.377,0,0,0,0,.53L44.7,87.621a.376.376,0,0,0,.531,0Z"
                fill="#102d40"
              />
            </g>
            <g className="exclamation">
              <path
                d="M60.968,87.617A5.813,5.813,0,1,1,65.9,90.355a5.786,5.786,0,0,1-4.934-2.738"
                fill="#ff4a56"
              />
              <path
                d="M64.824,86.793A1.078,1.078,0,1,0,65.9,85.715a1.078,1.078,0,0,0-1.078,1.078"
                fill="#102d40"
              />
              <path
                d="M65.053,85.027a.28.28,0,0,0,.28.266h1.139a.28.28,0,0,0,.28-.266l.174-3.187a.281.281,0,0,0-.28-.3H65.159a.281.281,0,0,0-.28.3Z"
                fill="#102d40"
              />
            </g>
          </g>
        </symbol>

        <symbol
          id="icon-esg-sdg-survey-managementUnavailable"
          viewBox="0 0 92 120"
        >
          <g>
            <g>
              <path
                fill="currentColor"
                d="M46,.5a7.728,7.728,0,0,1,7.719,7.719v.5H83.808a7.728,7.728,0,0,1,7.719,7.719v95.342a7.728,7.728,0,0,1-7.719,7.719H8.192a7.728,7.728,0,0,1-7.719-7.719V16.438A7.728,7.728,0,0,1,8.192,8.719H38.281v-.5A7.728,7.728,0,0,1,46,.5M46,0a8.219,8.219,0,0,0-8.219,8.219H8.192A8.219,8.219,0,0,0-.027,16.438v95.342A8.219,8.219,0,0,0,8.192,120H83.808a8.219,8.219,0,0,0,8.219-8.219V16.438a8.219,8.219,0,0,0-8.219-8.219H54.219A8.219,8.219,0,0,0,46,0Z"
              />
              <path
                fill="currentColor"
                d="M81.5,18.61v91h-71v-91h71m.5-.5H10v92H82v-92Z"
              />
              <path
                fill="currentColor"
                d="M46,5.568A2.171,2.171,0,1,1,43.829,7.74,2.174,2.174,0,0,1,46,5.568m0-.5A2.671,2.671,0,1,0,48.671,7.74,2.671,2.671,0,0,0,46,5.068Z"
              />
            </g>
            <g>
              <path
                d="M30.4,39.105v.375a.563.563,0,0,1-.562.563,4.65,4.65,0,0,1-2.832,4.5,4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H21.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H29.84A.563.563,0,0,1,30.4,39.105Z"
                fill="currentColor"
              />
              <path
                d="M28.34,40.043H23.465a4.4,4.4,0,0,0,.26,1.5h4.356A4.412,4.412,0,0,0,28.34,40.043Z"
                fill="#102d40"
              />
              <path
                d="M25.9,45.668a2.517,2.517,0,0,0-2.178,1.875H28.08A2.517,2.517,0,0,0,25.9,45.668Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="45.903" cy="44.543" r="5.813" fill="currentColor" />
              <path
                d="M49.543,43.308a.377.377,0,0,0,0-.53l-.531-.53a.375.375,0,0,0-.53,0l-3.517,3.517-1.642-1.642a.375.375,0,0,0-.53,0l-.531.53a.377.377,0,0,0,0,.53L44.7,47.621a.376.376,0,0,0,.531,0Z"
                fill="#102d40"
              />
            </g>
            <g>
              <path
                fill="currentColor"
                d="M67.008,44.543a4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H61.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H69.84a.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563A4.65,4.65,0,0,1,67.008,44.543Z"
              />
              <path
                d="M68.34,40.043H63.465c0,1.816,1.083,3.375,2.437,3.375S68.34,41.87,68.34,40.043Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="25.903" cy="64.543" r="5.813" fill="currentColor" />
              <circle cx="25.903" cy="66.793" r="1.078" fill="#102d40" />
              <path
                d="M25.053,65.027a.28.28,0,0,0,.28.266h1.139a.28.28,0,0,0,.28-.266l.174-3.187a.281.281,0,0,0-.28-.3H25.159a.281.281,0,0,0-.28.3Z"
                fill="#102d40"
              />
            </g>
            <g>
              <path
                d="M50.4,59.105v.375a.563.563,0,0,1-.562.563,4.65,4.65,0,0,1-2.832,4.5,4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H41.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H49.84A.563.563,0,0,1,50.4,59.105Z"
                fill="currentColor"
              />
              <path
                d="M45.9,65.668c-1.354,0-2.437,1.56-2.437,3.375H48.34C48.34,67.227,47.257,65.668,45.9,65.668Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="65.903" cy="64.543" r="5.813" fill="currentColor" />
              <path
                d="M69.543,63.308a.377.377,0,0,0,0-.53l-.531-.53a.375.375,0,0,0-.53,0l-3.517,3.517-1.642-1.642a.375.375,0,0,0-.53,0l-.531.53a.377.377,0,0,0,0,.53L64.7,67.621a.376.376,0,0,0,.531,0Z"
                fill="#102d40"
              />
            </g>
            <g>
              <path
                d="M27.008,84.543a4.651,4.651,0,0,1,2.832,4.5.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563H21.965a.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562,4.651,4.651,0,0,1,2.832-4.5,4.65,4.65,0,0,1-2.832-4.5.563.563,0,0,1-.562-.562v-.375a.563.563,0,0,1,.563-.562H29.84a.563.563,0,0,1,.563.563v.375a.563.563,0,0,1-.562.563A4.65,4.65,0,0,1,27.008,84.543Z"
                fill="currentColor"
              />
              <path
                d="M28.34,80.043H23.465c0,1.816,1.083,3.375,2.438,3.375S28.34,81.87,28.34,80.043Z"
                fill="#102d40"
              />
            </g>
            <g>
              <circle cx="45.903" cy="84.543" r="5.813" fill="currentColor" />
              <path
                d="M49.543,83.308a.377.377,0,0,0,0-.53l-.531-.53a.375.375,0,0,0-.53,0l-3.517,3.517-1.642-1.642a.375.375,0,0,0-.53,0l-.531.53a.377.377,0,0,0,0,.53L44.7,87.621a.376.376,0,0,0,.531,0Z"
                fill="#102d40"
              />
            </g>
            <g className="exclamation">
              <path
                d="M60.968,87.617A5.813,5.813,0,1,1,65.9,90.355a5.786,5.786,0,0,1-4.934-2.738"
                fill="currentColor"
              />
              <path
                d="M64.824,86.793A1.078,1.078,0,1,0,65.9,85.715a1.078,1.078,0,0,0-1.078,1.078"
                fill="#102d40"
              />
              <path
                d="M65.053,85.027a.28.28,0,0,0,.28.266h1.139a.28.28,0,0,0,.28-.266l.174-3.187a.281.281,0,0,0-.28-.3H65.159a.281.281,0,0,0-.28.3Z"
                fill="#102d40"
              />
            </g>
          </g>
        </symbol>

        <symbol id="circleRadar" viewBox="0 0 420 420">
          <circle cx="210" cy="210" />
        </symbol>

        <symbol id="arcRadar" viewBox="0 0 77.9 12">
          <path
            fill="currentColor"
            d="M1.5 12L0 4.1c27.3-5.3 50.6-5.5 77.9-.7l-1.4 7.9c-26.3-4.6-48.7-4.4-75 .7z"
          />
        </symbol>

        <symbol id="icon-sdg-impact-synthesis" viewBox="0 0 141 141">
          <path
            fill="#FFF"
            d="M79.4 83.8L86 94.5c2.7-1.7 5-3.8 7-6.4l-10-7.6c-1 1.3-2.2 2.4-3.6 3.3zM75.7 55.4l3.6-9.5c-2.7-1-5.5-1.5-8.4-1.5v10.2c1.7 0 3.3.3 4.8.8zM80.8 58.3l27.6-30.8c-5-4.5-10.7-8-17-10.4L76.7 55.8c1.4.6 2.8 1.5 4.1 2.5zM86.3 68.3l22.6-2.4c-.5-4.4-1.7-8.7-3.8-12.6L84.9 63.7c.7 1.4 1.2 3 1.4 4.6zM86.5 70.5c0 1.2-.2 2.4-.4 3.6l46.3 12.4c2-7.3 2.6-14.8 1.8-22.3l-47.7 5v1.3zM83.6 79.7l11.8 8.9c2.1-2.9 3.7-6.2 4.7-9.7l-14.3-3.8c-.5 1.7-1.2 3.2-2.2 4.6zM74 86.1l4 20.4c4.1-.8 8-2.3 11.6-4.5l-11-17.7c-1.5.9-3 1.5-4.6 1.8zM70.5 86.5c-.8 0-1.5-.1-2.3-.2L59.8 134c7.4 1.3 15 1.3 22.4-.2L73 86.3c-.8.2-1.6.2-2.5.2zM62.7 84.5l-18.8 31.3c5.2 3.1 11 5.3 17 6.3l6.3-35.9c-1.6-.4-3.1-.9-4.5-1.7zM58.2 80.7L37.4 97.1c3 3.8 6.7 7.1 10.9 9.6L61.9 84c-1.4-.9-2.6-2-3.7-3.3zM59.3 59.2l-6-6.5c-2 1.9-3.6 4-4.8 6.5l7.9 3.9c.8-1.5 1.7-2.8 2.9-3.9zM64.1 55.9L53.6 29.8c-4.7 1.9-9 4.6-12.7 8.1L60 58.5c1.2-1.1 2.6-1.9 4.1-2.6zM70 54.6V19.1c-6.2 0-12.4 1.2-18.2 3.5L65 55.5c1.6-.6 3.3-.9 5-.9z"
          />
          <path
            fill="none"
            stroke="#193566"
            strokeMiterlimit="10"
            d="M70 .8c-8.6 0-17.1 1.7-25.1 4.9"
          />
          <path
            fill="none"
            stroke="#02558A"
            strokeMiterlimit="10"
            d="M23.4 19.1C29.4 13.5 36.4 9 44 6"
          />
          <path
            fill="none"
            stroke="#3EAF49"
            strokeMiterlimit="10"
            d="M22.7 19.8c-6 5.6-11 12.2-14.6 19.6"
          />
          <path
            fill="none"
            stroke="#017CBB"
            strokeMiterlimit="10"
            d="M7.7 40.3C4 47.7 1.8 55.7 1.1 63.9"
          />
          <path
            fill="none"
            stroke="#46763B"
            strokeMiterlimit="10"
            d="M1 64.9c-.7 8.2.1 16.5 2.4 24.4"
          />
          <path
            fill="none"
            stroke="#CF8D29"
            strokeMiterlimit="10"
            d="M3.6 90.2c2.4 8.3 6.4 16 11.7 22.9"
          />
          <path
            fill="none"
            stroke="#F89C24"
            strokeMiterlimit="10"
            d="M34.3 130c-7.1-4.2-13.3-9.7-18.3-16.2"
          />
          <path
            fill="none"
            stroke="#E11983"
            strokeMiterlimit="10"
            d="M35.1 130.5c7 4.2 14.8 7.1 22.8 8.5"
          />
          <path
            fill="none"
            stroke="#F26C24"
            strokeMiterlimit="10"
            d="M83.3 139c-8 1.6-16.3 1.7-24.3.2"
          />
          <path
            fill="none"
            stroke="#8E1737"
            strokeMiterlimit="10"
            d="M106.9 129.9c-6.9 4.4-14.6 7.4-22.7 8.9"
          />
          <path
            fill="none"
            stroke="#FCB614"
            strokeMiterlimit="10"
            d="M125.8 112.9c-4.9 6.6-11 12.2-18 16.5"
          />
          <path
            fill="none"
            stroke="#00ADD9"
            strokeMiterlimit="10"
            d="M137.7 89.1c-2.3 8.3-6.1 16.1-11.3 23.1"
          />
          <path
            fill="none"
            stroke="#EF3E2A"
            strokeMiterlimit="10"
            d="M139.9 63.7c.9 8.2.2 16.5-1.9 24.4"
          />
          <path
            fill="none"
            stroke="#C21F32"
            strokeMiterlimit="10"
            d="M139.8 62.7c-.8-8.2-3.2-16.2-7-23.5"
          />
          <path
            fill="none"
            stroke="#269B47"
            strokeMiterlimit="10"
            d="M117.4 18.9c6.1 5.5 11.2 12 14.9 19.4"
          />
          <path
            fill="none"
            stroke="#D19E28"
            strokeMiterlimit="10"
            d="M116.7 18.3c-6.1-5.5-13.1-9.8-20.8-12.7"
          />
          <path
            fill="none"
            stroke="#EB1C2B"
            strokeMiterlimit="10"
            d="M95 5.2C87.4 2.2 79.2.7 71 .8"
          />
        </symbol>

        <symbol id="icon-sdg-contribution" viewBox="0 0 160 82">
          <path
            fill="none"
            stroke="#FFF"
            strokeWidth=".5"
            strokeMiterlimit="10"
            d="M0 81.8h160"
          />
          <path fill="#2B77A6" d="M9 0h10v79H9z" />
          <path
            fill="#41A3D7"
            d="M21 10h10v69H21zM33 14h10v65H33zM45 23h10v56H45zM57 26h10v53H57z"
          />
          <path
            fill="#C2E6F7"
            d="M69 36h10v43H69zM81 46h10v33H81zM93 56h10v23H93zM105 60h10v19h-10z"
          />
          <path
            fill="#FFF"
            d="M117 65h10v14h-10zM129 73h10v6h-10zM141 77h10v2h-10z"
          />
        </symbol>

        <symbol id="icon-user-management" viewBox="0 0 640 512">
          <path
            fill="currentColor"
            d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
          />
        </symbol>

        <symbol id="icon-spv-manager" viewBox="0 0 32 28">
          <path
            fill="currentColor"
            d="M2 26c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V8H2v18zm10-13.2c0-.4.3-.8.8-.8h6.5c.4 0 .8.4.8.8v.5c0 .4-.4.8-.8.8h-6.5c-.4 0-.8-.3-.8-.8v-.5zM30 0H2C.9 0 0 .9 0 2v3c0 .6.4 1 1 1h30c.5 0 1-.4 1-1V2c0-1.1-.9-2-2-2z"
          />
        </symbol>

        <symbol id="icon-country-list" viewBox="0 0 31 31">
          <path
            fill="currentColor"
            d="M15.5 0C6.9 0 0 6.9 0 15.5S6.9 31 15.5 31 31 24.1 31 15.5 24.1 0 15.5 0zM28 15.5c0 1.4-.2 2.8-.7 4.1H26c-.2 0-.5-.1-.7-.3l-2-2.1c-.2-.2-.2-.8 0-1l.8-.8v-.5c0-.2-.1-.4-.2-.5l-.6-.6c-.1-.1-.3-.2-.5-.2h-1c-.4 0-.7-.3-.7-.7 0-.2.1-.4.2-.5l.6-.6c.1-.1.3-.2.5-.2h2c.4 0 .8-.3.8-.7v-.6c0-.4-.3-.7-.8-.7h-2.2c-.6 0-1 .4-1 1v.2c0 .4-.3.8-.7 1l-2 .6c-.2.1-.3.2-.3.5v.1c0 .2-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5s-.2-.5-.5-.5h-.2c-.2 0-.4.1-.5.2l-.6 1.3c-.2.3-.5.6-.9.6h-1.4c-.6 0-1-.4-1-1V12c0-.2.1-.5.2-.7l1.2-1.2c.3-.3.5-.7.5-1.1 0-.2.1-.4.3-.5l2.5-.8c.1-.1.2-.1.2-.2l1.7-1.7c.1-.1.2-.3.2-.5 0-.4-.4-.7-.8-.7h-1.2l-1 1v.5c0 .2-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5V4.8c0-.2.1-.3.2-.4l1.8-1.3c.1 0 .2-.1.3-.1C22.4 3 28 8.6 28 15.5zM8.1 8.9c0-.2.1-.4.2-.5l1.6-1.6c.1-.1.3-.2.5-.2.4 0 .8.3.8.7v1c0 .2-.1.4-.2.5l-.6.6c-.2.1-.4.2-.6.2h-1c-.4 0-.7-.4-.7-.7zm8 19.1v-.4c0-.6-.5-1-1-1h-1.3c-.6 0-1.6-.3-2.2-.8l-1.4-1.1c-.8-.5-1.1-1.4-1.1-2.2V21c0-1 .5-1.9 1.4-2.4l2.7-1.6c.4-.2.9-.4 1.4-.4h1.9c.7 0 1.4.2 1.9.7l2.7 2.3h1.1c.6 0 1.1.2 1.4.6l1.1 1.1c.2.2.5.3.8.3h.9c-2 3.6-5.8 6.2-10.3 6.4z"
          />
        </symbol>

        <symbol id="icon-country-data" viewBox="0 0 32 28">
          <path
            fill="currentColor"
            d="M29 0H3C1.3 0 0 1.4 0 3v22c0 1.7 1.3 3 3 3h26c1.6 0 3-1.3 3-3V3c0-1.6-1.4-3-3-3zM14 24H4v-6h10v6zm0-10H4V8h10v6zm14 10H18v-6h10v6zm0-10H18V8h10v6z"
          />
        </symbol>

        <symbol id="icon-reporting" viewBox="0 0 80 46">
          <path
            fill="#ECF4F9"
            d="M79 0H1C.7 0 .5.1.3.3.1.5 0 .7 0 1v44c0 .3.1.5.3.7.2.2.4.3.7.3h78c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7V1c0-.3-.1-.5-.3-.7-.2-.2-.4-.3-.7-.3z"
          />
          <path
            fill="none"
            stroke="#102D40"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M5.6 5.5h40.1M5.6 8.5h27.6"
          />
          <path
            fill="#2B77A6"
            stroke="#2B77A6"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M71.7 8.5c.4 0 .8-.2 1.1-.4.2-.3.4-.7.4-1.1s-.2-.8-.4-1.1c-.3-.3-.7-.4-1.1-.4h-3c-.4 0-.8.2-1.1.4-.3.3-.4.7-.4 1.1s.2.8.4 1.1c.3.3.7.4 1.1.4h3z"
          />
          <path
            fill="#FFF"
            d="M68.7 8.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5.7 1.5 1.5 1.5zM80 13v32c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3H1c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7V13h80z"
          />
          <path
            fill="#D4FFF2"
            d="M72.3 16h-64c-1.7 0-3 1.3-3 3s1.3 3 3 3h64c1.7 0 3-1.3 3-3s-1.4-3-3-3z"
          />
          <path
            fill="none"
            stroke="#1AD49B"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M48.5 19h18"
          />
          <path
            fill="#1AD49B"
            d="M72.3 22c-.6 0-1.2-.2-1.7-.5s-.9-.8-1.1-1.3c-.2-.5-.3-1.2-.2-1.7.1-.6.4-1.1.8-1.5.4-.4 1-.7 1.5-.8.6-.1 1.2-.1 1.7.2.5.2 1 .6 1.3 1.1.3.5.5 1.1.5 1.7 0 .8-.3 1.6-.9 2.1-.4.4-1.1.7-1.9.7zm1.9-3.6.1-.1c0-.1 0-.1-.1-.1l-.3-.3-.1-.1s-.1 0-.1.1l-1.8 1.8-.8-.8-.1-.1c-.1 0-.1 0-.1.1l-.3.3v.4l1.3 1.3.1.1s.1 0 .1-.1l2.1-2.5z"
          />
          <path
            fill="#D4FFF2"
            d="M72.3 37h-64c-1.7 0-3 1.3-3 3s1.3 3 3 3h64c1.7 0 3-1.3 3-3s-1.4-3-3-3z"
          />
          <path
            fill="none"
            stroke="#1AD49B"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M48.5 40h18"
          />
          <path
            fill="#1AD49B"
            d="M72.3 43c-.6 0-1.2-.2-1.7-.5s-.9-.8-1.1-1.3c-.2-.5-.3-1.2-.2-1.7.1-.6.4-1.1.8-1.5.4-.4 1-.7 1.5-.8.6-.1 1.2-.1 1.7.2.5.2 1 .6 1.3 1.1.3.5.5 1.1.5 1.7 0 .8-.3 1.6-.9 2.1-.4.4-1.1.7-1.9.7zm1.9-3.6.1-.1s0-.1-.1-.1l-.3-.3-.1-.1s-.1 0-.1.1l-1.8 1.8-.8-.9-.1-.1c-.1 0-.1 0-.1.1l-.3.3v.4l1.3 1.3.1.1s.1 0 .1-.1l2.1-2.4z"
          />
          <path
            fill="#FCDADC"
            d="M72.3 23h-64c-1.7 0-3 1.3-3 3s1.3 3 3 3h64c1.7 0 3-1.3 3-3s-1.4-3-3-3z"
          />
          <path
            fill="none"
            stroke="#FFF"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M48.5 26h18"
          />
          <path
            fill="#FF4A56"
            d="M75.3 26c0 .6-.2 1.2-.5 1.7s-.8.9-1.3 1.1c-.5.2-1.2.3-1.7.2-.6-.1-1.1-.4-1.5-.8-.4-.4-.7-1-.8-1.5-.1-.6-.1-1.2.2-1.7.2-.5.6-1 1.1-1.3.5-.3 1.1-.5 1.7-.5.8 0 1.6.3 2.1.9.4.3.7 1.1.7 1.9zM73 26l.8-.8V25l-.5-.5h-.2l-.8.8-.8-.8h-.2l-.5.5v.2l.8.8-.8.8v.2l.5.5h.2l.8-.8.8.8h.2l.5-.5v-.2L73 26z"
          />
          <path
            fill="#ECF4F9"
            d="M72.3 30h-64c-1.7 0-3 1.3-3 3s1.3 3 3 3h64c1.7 0 3-1.3 3-3s-1.4-3-3-3z"
          />
          <path
            fill="none"
            stroke="#FFF"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M48.5 33h18"
          />
          <path
            fill="none"
            stroke="#2B77A6"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M48.5 33h6"
          />
        </symbol>

        <symbol id="useArrow" viewBox="0 0 47 16">
          <g
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          >
            <path d="M2.11 12.03a30 30 0 0142.42.63" />
            <path d="M43.86 1.72l.99 11.27-11.27.99" />
          </g>
        </symbol>

        <symbol id="centerMap" viewBox="0 0 16 16">
          <g
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
          >
            <circle cx="8.07" cy="8" r="3.2" />
            <path d="M11.27 8h4" />
            <path d="M8.07 11.19v4" />
            <path d="M4.87 8h-4" />
            <path d="M8.07 4.8v-4" />
          </g>
        </symbol>

        <symbol id="zoominMap" viewBox="0 0 16 16">
          <path
            id="zoominMap"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M12.46 8h-8.8"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M8.06 12.4V3.6"
          />
        </symbol>

        <symbol id="zoomoutMap" viewBox="0 0 16 16">
          <path
            id="zoomoutMap"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M12.46 8h-8.8"
          />
        </symbol>

        <symbol id="legendSize" viewBox="0 0 11.02 11.02">
          <g
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          >
            <path d="M6.07 4.74L9.61 1.2" />
            <path d="M6.78 1.2h2.83v2.83" />
          </g>
          <g
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          >
            <path d="M4.54 6.27L1 9.81" />
            <path d="M3.83 9.81H1V6.98" />
          </g>
        </symbol>

        <symbol id="arrowSwipe" viewBox="0 0 33 15">
          <g
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          >
            <path d="M1.5 7.5h30" />
            <path d="M25.5 1.5l6 6-6 6" />
          </g>
        </symbol>

        <symbol id="icon-lp-dashboard" viewBox="0 0 92 136">
          <rect width="92" height="40" rx="2" ry="2" fill="#f2e068" />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M16 33V12"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M21 33V17.17"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M26 33V18.5"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M31 33V20"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M36 33V21.33"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M41 33V21.33"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M46 33V21.33"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M51 33v-9"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M56 33v-8.33"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M61 33v-8.33"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M66 33v-7"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M71 33v-6.67"
          />
          <rect y="96" width="92" height="40" rx="2" ry="2" fill="#1ad49b" />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M76 33v-6.67"
          />
          <rect y="42" width="92" height="52" rx="2" ry="2" fill="#2b77a6" />
          <g fill="#fff">
            <path d="M53.64 78.08l.48-.31.6-.72.16.03-.1 1.85-.44 1.27-.55.16-.46-.8.3-.4v-1.08z" />
            <path d="M61.24 71.78l-.22.5.22.42h.37l.07-.6-.44-.31z" />
            <path d="M64.23 72.86l.43.87.7.31.59 1.25.56.27.02-1-1-.63-.28-.6-1.02-.47z" />
            <path d="M66.82 75.72l-.11.26.76.38 1.77.07-.02-.38-1.31-.07-.83-.33-.26.06z" />
            <path d="M67.1 73.6l.7.1L69 72.6l.28.24-.28.4.3.72-.59 1.18-1.28-.35-.33-1.19z" />
            <path d="M70.26 73.57l-.41.3-.2.42-.44.49.2.94h.15l.2-.9.28.65.3-.56-.17-.24.53-.2-.72-.12.06-.22.55-.02.34-.54h-.67z" />
            <path d="M71.94 74.4l.22.38-.05.44.9.05.43 1.1.83.1.39-.51.55.78 1.06.11-.87-.87.24-.47-.83-.2-.17-.38-1.29-.56-.43.23-.57-.4-.41.2z" />
            <path d="M20.94 53.08h-2.4l-1.65.5-3.53-.77-1.74.85.91.98-1.43.05.39.53.87.27-.61.4-.96-.04-.22.53 1.14.99-.3.62 1.25-.27 1.18-1.52-.17.8.96-.66 1.82.76 1.14 1.7.04.75.57.63h-.44l-.3 2.68.35 1.07.7.71.04 1.34 1.17 1.3-.43-1.34-.05-.63 1.05 1.48.13 1.16 1.83.93h.78l.83.76.57.14.3.84.79.14.43.62-.56 1.79 1.13 3.44 1.05.89-.1 3.62-.17.49.4 4.6.65.35 1-.71-.48-.76.52-.67-.34-.85.6-.09.1-.62 1.04-.27.13-.54-.57-.53.96-.05 1.13-1.56-.17-.8 1.87-.85.22-2.19.92-1.07.17-.98-1.96-.54-1.05-.76-1 .14.3-.8-.56-.68-1.09-.44-.91-.8h-.92l-.87-.32-1.15 1-.43-.53-.6-.07v-1.25L24 68.8l.48-1.21-.91-.27-.26.58-1.05-.58.04-1.07.74-.67.66.05.39-.45.78.13.61 1.34.35-.58-.17-.94-.09-.44 1.22-.8v-1.12l1.3-.72.14-.67.87-.49-.22.58 1.18-.53-.53-.36v-.53l-1.04.3.52-.8 1.31.1 1.05-.85-.31-.76-.74-.4-.13-1.48-.92.67-.48-.85-1.21-.31-.53.9.4.88-.57.54-.18 1.3-.6-1.16L24.16 57l.48-1.34 1.43-.4.57-1.03.7-.58-.44-.62-.7.71-1.26-1.25-.74.98-.7-.13-.83.98-.78-1.16-.87.31-.09-.4z" />
            <path d="M27.65 55.09l.4-.63.47-.04.22-.67-1.48-1.03-.61.27-.4-.58.31-.8 1.79.4.7.58 1.13.45-.52.71.52.31-.52.14.56.8-.65.54-.61-.45h-1.3z" />
            <path d="M30.1 49.29l.86.62-1.17.18.35.53 1.91.1.35 1.24.48.5.09.66-.44.5-.35 1.43 1.53 1.7.78-1.08.26-.85 1.48-.49.22-.53 1.88-.4-.44-.85.26-.14.26.4.35-.58-.43-.53.6-.85-.56-.63.83-.3-.4-.46 1.27-.76-.35-.22-.78.45-.53-.5-1.74-.35.52-.58-2.13.13-.48.76L33 48l-2.92 1.3z" />
            <path d="M38.24 54.29l-.35.44.87.9 1.3-.54-.12-.9-.79.32-.91-.22z" />
            <path d="M30.27 60.31l.6-.71.66-.31-.13.49.83.13-.44.72-.3-.4-1.22.08z" />
            <path d="M28.13 86.67l.48.07.52-.42.03.64.6.54-1.2-.27-.43-.56z" />
            <path d="M25.99 66.95l-.61-.02-.47.32.77.06.58.42-.1.2.9-.16-.44-.3-.63-.52z" />
            <path d="M27.22 67.86l.25.27-.52.19 1.12.1.27-.17-.45-.24-.67-.15z" />
            <path d="M77.35 84.61l.17-.31 1.45-.8.23.38-.3.44-.45.05-.68.52-.42-.28z" />
            <path d="M79.24 83.51l.56-.6-.38-.62.44.18.15.48.74.06-1.28.8-.23-.3z" />
            <path d="M45.36 60.83l.13-.36.33-.34.52-.29-.3-.6.35-.49.41.07-.26.6.24.56.74-.22 1.15.02-.02-.85.68-.18-.24-.56.85-.09.13-.3-1.44.08v-.83l.46-.29.48-.62-.8.04-.25.52-.74.71.3.9-.8.93-.2-.1-.27-1.2-.8.48-.32-1.34 1.04-.7 1.37-1.91.8-.18 1.14-.18 2.29 1.31-1.29.34.7.96 1.25-.6-.1-.8 1.2-.22.4.53 1.26-1 1.29.6-.04-.84.79-.02.32 1.01h1.37l-.91-1.23.1-.51 1.14-.4.2-.58 2.4-.22 1.62.34-.14.8 2.4-.07 1.5-.34.48.96 1.63-.1.03-.34.98-.1 2.15.74 1.85.1.4.4 3.05-.05.28.94 1.09-.12.02.58-.92.4-.15-.53-.91.18.6 1-1.17.06-.5.78-.3-.33-.62.47.14 1.27-.61 1.34-.61-2.18.96-1.32-.7.3-.61-.26-.76.83-1.22.07-1.16 1.25.16.44.91-.13.07.45-.98 2.79-.53.15.09.34-.33.29-.06.51.39.6-.59.56-.1-.78-.33-.16v-.85l-.72.52-.2-.16-.42.47.9.13-.37.5.65 1.51-1.2 2.2-.12.4-1.16.06-.36-.07-.45.4.8.86-.12 1.11-1.1.52.05-.8-.7-.34-.01 1.07.8.7.29 1.22-.87-.52-.17-.85-.66-.8.09-1.5-.24-.22-.65.22-.52-1.05-.03-.46-.15-.32-.74.36-.2.56-1.26 1.36-.02.67-.74.7-.55-1.88-.22-1.36-.35.09-.15-.47-.37.2-.37-.7-.37-.28-1.3.15-.27-.51-.98-.04-.5-.65-.4.02-.06.25.27.38.13.73.08-.29.18-.02.04.33.48.2.63-.58.09.52.59.31-.05.58-.37.4-1.3 1.1-.98.17-.48.25-.33-1.16-.09-.6-.72-.49-.06-.5-.52-.68-.22-1-.15.58-.48-.36 1.4 2.7.06.74 1 .91-.03.45 1.72-.51-.41 1.35-2.05 2.43v3.08l-1.09.83.13 1.23-.54.4-.04.55-1.27 1.52-1.33.26-.54-.55-.13-.94-.63-.8.08-1-.67-1.41.4-1.05-.07-1.52-.96-1.2.26-.94-1.13-.67-2.68.22-1.87-2.83.37-.85.06-1.3 1.42-1.56.08-.73.92-.6.6.22 1.12-.54 1.4.05-.05.8 1.83.76.28-.52 1.81.5.26-.25.79-.02L52 65l-.79-.38-.3.22-.74-.09-.02-.35-.16-.25.17-.31.42-.25.9-.24.53.36.79-.18-.04-.47-.99-.56.35-.13-.2-.34-.5.11.24.27-.13.22-.41-.2.15-.3h-.32l-.74.82.22.58-.24-.03-.07.22-.23-.04-.57.04-.07.3.22.2.02.37.07.32-.26-.16-.07.36-.11-.31-.22.22v-.6l.48-.06-.54-.11-.22-.8-.7-.34-.66-.56-.15.18.42.56.52.33.3.4-.48-.2.05.47-.28.38-.03-.62-.28-.34-.37-.29-.33-.35-.65.04-.76.42-.76.94-.83.45-.8-.67.01-1.36 1.46-.07-.6-.98v-.3l.6-.04-.08-.33.45.22.27-.42.4-.14zm9.22.43l-.52.63.64.95s-.23.86-.15.86 1.04.32 1.04.32v-1.28l-.65-.56.42-.38z" />
            <path d="M55.15 52.93l-1.24.77.57.32-.33.28-.84-.53.27-.48 1.57-.36z" />
            <path d="M48.6 52.34l-1.23.6-.65-.42 1.18-.26.7.08z" />
            <path d="M43.74 58.66l-.28.43.45.33-.16.22.3.3-.15.22-.22.26.43.08-.8.47h.83l.44-.1.48-.08-.16-.1.2-.2-.4-.14-.1-.46-.41-.25.25-.39-.4-.24.1-.23-.4-.12z" />
            <path d="M42.94 59.6l.22-.13.37.2-.24.99-.77.26-.13-.33.35-.45-.23-.3.42-.07.01-.16z" />
            <path d="M70.63 71.85l-.3.2-.07.65.33.07.58-.31-.54-.6z" />
            <path d="M70.24 70.87l-.22.27-.1.47.34.22.3-.27-.32-.69z" />
            <path d="M69.67 69.53l-.37.47.48.94.28-.65-.39-.76z" />
            <path d="M69.7 67.61l-.42.31.04.67.66-.26-.29-.72z" />
            <path d="M71.4 65.42l.32.43-.26.91-.42-.69.35-.65z" />
            <path d="M71.78 65.16l.94-.45.22-1.23.65.5-.37.33-.04.96-.63.42-.18.27-.26-.5-.33-.3z" />
            <path d="M73.18 62.57l-.09.53.57.27.28-.58-.76-.22z" />
            <path d="M72.61 59.78l-.04.33.35.83-.16.96.35.24.29-1.6-.79-.76z" />
            <path d="M71.68 77.05l-.27.72-.52-.36-.87.9-.3-.19-.44.94-1.3.54-.14 3.44 3.31-.9.7.63.52-.1-.13.41 1.18 1.25.39-.4.35.44.83-.8 1-1.87-.13-1.39-1.66-3.21-.56 1.34-.79-.23-.04-1.07-1.13-.09z" />
          </g>
          <circle cx="19.34" cy="114.41" r="7.88" fill="#fff" />
          <circle cx="29.8" cy="120.76" r="5.73" fill="#fff" />
          <circle cx="37.45" cy="114.41" r="4.89" fill="#fff" />
          <circle cx="63.59" cy="122.14" r="3.58" fill="#fff" />
          <circle cx="51.37" cy="117.18" r="2.15" fill="#fff" />
          <circle cx="75.5" cy="109.63" r="1.43" fill="#fff" />
          <circle cx="77.89" cy="113.21" r="2.87" fill="#fff" />
          <circle cx="80.28" cy="108.44" r="2.15" fill="#fff" />
        </symbol>

        <svg id="survey-editor-small" viewBox="0 0 80 46">
          <path d="M40 14H1a1 1 0 01-1-1V1a1 1 0 011-1h39" fill="#fff" />
          <path d="M40 0h39a1 1 0 011 1v12a1 1 0 01-1 1H40V0z" fill="#2b77a6" />
          <path d="M40 30H1a1 1 0 01-1-1V17a1 1 0 011-1h39" fill="#fff" />
          <path
            d="M40 16h39a1 1 0 011 1v12a1 1 0 01-1 1H40V16z"
            fill="#f2e068"
          />
          <path d="M40 46H1a1 1 0 01-1-1V33a1 1 0 011-1h39" fill="#fff" />
          <path
            d="M40 32h39a1 1 0 011 1v12a1 1 0 01-1 1H40V32z"
            fill="#1ad49b"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5.55 5.5h19.08"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5.55 8.5h6.58"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5.55 21.5h26.08"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5.55 24.5h11.58"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5.55 37.5h24.08"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M5.55 40.5h15.58"
          />
          <path
            d="M46.7 24.5a1.5 1.5 0 010-3h18a1.5 1.5 0 010 3z"
            fill="#fff"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            d="M57.67 39h4.79"
          />
          <path d="M46.7 40.5a1.5 1.5 0 010-3h8a1.5 1.5 0 110 3z" fill="#fff" />
          <g>
            <circle cx="46.69" cy="7" r="1.5" fill="#fff" />
            <circle cx="46.69" cy="7" r="1" fill="#102d40" />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              d="M49.67 7h3.79"
            />
          </g>
          <g>
            <circle cx="56.69" cy="7" r="1.5" fill="#fff" />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              d="M59.67 7h3.79"
            />
          </g>
          <g>
            <circle cx="66.69" cy="7" r="1.5" fill="#fff" />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              d="M69.67 7h3.79"
            />
          </g>
        </svg>

        <symbol id="icon-survey-editor" viewBox="0 0 100 135">
          <path
            d="M50 37H1.25A1.25 1.25 0 010 35.75v-15a1.25 1.25 0 011.25-1.25H50"
            fill="#fff"
          />
          <path
            d="M50 19.5h49a1 1 0 011 1V36a1 1 0 01-1 1H50V19.5z"
            fill="#f2e068"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M6.93 26.38h32.61"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M6.93 30.13h14.48"
          />
          <path
            d="M58.37 30.13a1.88 1.88 0 010-3.75h22.5a1.88 1.88 0 010 3.75z"
            fill="#fff"
          />
          <path
            d="M50 56.5H1.25A1.25 1.25 0 010 55.25v-15A1.25 1.25 0 011.25 39H50"
            fill="#fff"
          />
          <path
            d="M50 39h49a1 1 0 011 1v15.5a1 1 0 01-1 1H50V39z"
            fill="#1ad49b"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M6.93 45.88h30.11"
          />
          <path
            fill="none"
            stroke="#102d40"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M6.93 49.63h19.48"
          />
          <g>
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              d="M72.09 47.75h5.99"
            />
            <path
              d="M58.37 49.63a1.88 1.88 0 010-3.76h10a1.88 1.88 0 010 3.76z"
              fill="#fff"
            />
          </g>
          <g>
            <path
              d="M50 17.5H1.25A1.25 1.25 0 010 16.25v-15A1.25 1.25 0 011.25 0H50"
              fill="#fff"
            />
            <path
              d="M50 0h49a1 1 0 011 1v15.5a1 1 0 01-1 1H50V0z"
              fill="#2b77a6"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 6.88h23.86"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 10.63h8.23"
            />
            <circle cx="58.37" cy="8.75" r="1.88" fill="#fff" />
            <circle cx="58.37" cy="8.75" r="1.25" fill="#102d40" />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              d="M62.09 8.75h4.74"
            />
            <g>
              <circle cx="70.86" cy="8.75" r="1.88" fill="#fff" />
              <path
                fill="none"
                stroke="#102d40"
                strokeMiterlimit="10"
                d="M74.59 8.75h4.74"
              />
            </g>
            <g>
              <circle cx="83.36" cy="8.75" r="1.88" fill="#fff" />
              <path
                fill="none"
                stroke="#102d40"
                strokeMiterlimit="10"
                d="M87.09 8.75h4.74"
              />
            </g>
          </g>
          <g>
            <path
              d="M50 135H1.25A1.25 1.25 0 010 133.75v-15a1.25 1.25 0 011.25-1.25H50"
              fill="#fff"
            />
            <path
              d="M50 117.5h49a1 1 0 011 1V134a1 1 0 01-1 1H50v-17.5z"
              fill="#f2e068"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 124.38h23.86"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 128.13h8.23"
            />
            <circle cx="58.37" cy="126.25" r="1.88" fill="#fff" />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              d="M62.09 126.25h4.74"
            />
            <g>
              <circle cx="70.86" cy="126.25" r="1.88" fill="#fff" />
              <path
                fill="none"
                stroke="#102d40"
                strokeMiterlimit="10"
                d="M74.59 126.25h4.74"
              />
            </g>
            <g>
              <circle cx="83.36" cy="126.25" r="1.88" fill="#fff" />
              <path
                fill="none"
                stroke="#102d40"
                strokeMiterlimit="10"
                d="M87.09 126.25h4.74"
              />
            </g>
          </g>
          <g>
            <path
              d="M50 96H1.25A1.25 1.25 0 010 94.75v-35a1.25 1.25 0 011.25-1.25H50"
              fill="#fff"
            />
            <path
              d="M50 58.5h49a1 1 0 011 1V95a1 1 0 01-1 1H50V58.5z"
              fill="#2b77a6"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 65.38h32.61"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 69.13h14.48"
            />
            <rect
              x="56.49"
              y="65.38"
              width="26.25"
              height="23.75"
              rx="2"
              ry="2"
              fill="#fff"
            />
          </g>
          <g>
            <path
              d="M50 115.5H1.25A1.25 1.25 0 010 114.25v-15A1.25 1.25 0 011.25 98H50"
              fill="#fff"
            />
            <path
              d="M50 98h49a1 1 0 011 1v15.5a1 1 0 01-1 1H50V98z"
              fill="#1ad49b"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 104.88h30.11"
            />
            <path
              fill="none"
              stroke="#102d40"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M6.93 108.63h19.48"
            />
            <g>
              <path
                fill="none"
                stroke="#102d40"
                strokeMiterlimit="10"
                d="M72.09 106.75h5.99"
              />
              <path
                d="M58.37 108.63a1.88 1.88 0 010-3.75h10a1.88 1.88 0 010 3.75z"
                fill="#fff"
              />
            </g>
          </g>
        </symbol>

        {/* <symbol id="icon-key-impact-global" viewBox="0 0 42 42">
          <path d="M19 40a19 19 0 010-38" fill="#2b77a6" />
          <path d="M23 2a19 19 0 010 38" fill="#2b77a6" />
          <path
            d="M16.36 24.9v1.13a1.31 1.31 0 01-1.3 1.31H5.42a1.31 1.31 0 01-1.32-1.3v-1.15c0-1.97 1.06-3.56 3.01-3.66l1.8 5.24.88-3.72-.88-1.53h2.63l-.88 1.53.88 3.72 1.8-5.23c1.96.09 3.01 1.68 3.01 3.65zm-9.62-8.06a3.5 3.5 0 113.5 3.5 3.5 3.5 0 01-3.5-3.5z"
            fill="#6dc3e5"
          />
          <path
            d="M35.53 23.33a3.31 3.31 0 01-3.1 2.13v1.41a.47.47 0 01-.47.47h-.93a.47.47 0 01-.47-.47v-1.4a4.14 4.14 0 01-2.54-.88.47.47 0 01-.05-.72l1.02-1a.46.46 0 01.57-.06 1.79 1.79 0 001 .31h1.95a.86.86 0 00.24-1.7l-3-.87a3.35 3.35 0 01-2.45-2.83 3.21 3.21 0 013.2-3.5h.06v-1.4a.47.47 0 01.47-.48h.94a.47.47 0 01.47.47v1.4a4.14 4.14 0 012.53.89.47.47 0 01.06.71l-1.02 1a.46.46 0 01-.57.06 1.79 1.79 0 00-1-.3h-1.95a.86.86 0 00-.24 1.69l3.16.92a3.22 3.22 0 012.12 4.15z"
            fill="#6dc3e5"
          />
        </symbol> */}

        <symbol id="icon-global-sdg-rating" viewBox="0 0 30 30">
          <path
            id="sdg17"
            d="M10.132,2.946A12.856,12.856,0,0,1,15,2"
            fill="none"
            stroke="#193566"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg16"
            d="M6.138,5.491a12.278,12.278,0,0,1,3.994-2.545"
            fill="none"
            stroke="#02558a"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg15"
            d="M3.321,9.3A12.278,12.278,0,0,1,6.138,5.491"
            fill="none"
            stroke="#3eaf49"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg14"
            d="M2.055,13.861A12.278,12.278,0,0,1,3.321,9.3"
            fill="none"
            stroke="#017cbb"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg13"
            d="M2.509,18.575a12.278,12.278,0,0,1-.454-4.714"
            fill="none"
            stroke="#46763b"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg12"
            d="M4.76,22.993a12.856,12.856,0,0,1-2.251-4.418"
            fill="none"
            stroke="#cf8d29"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg11"
            d="M8.307,26.131A12.278,12.278,0,0,1,4.76,22.993"
            fill="none"
            stroke="#f89c24"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg10"
            d="M12.743,27.79a12.278,12.278,0,0,1-4.436-1.659"
            fill="none"
            stroke="#e11983"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg9"
            d="M17.478,27.748a12.278,12.278,0,0,1-4.736.041"
            fill="none"
            stroke="#f26c24"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg8"
            d="M21.885,26.013a12.278,12.278,0,0,1-4.406,1.736"
            fill="none"
            stroke="#8e1737"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg7"
            d="M25.376,22.813a12.278,12.278,0,0,1-3.492,3.2"
            fill="none"
            stroke="#fcb614"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg6"
            d="M27.55,18.357a12.856,12.856,0,0,1-2.174,4.457"
            fill="none"
            stroke="#00add9"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg5"
            d="M27.922,13.635a12.278,12.278,0,0,1-.372,4.721"
            fill="none"
            stroke="#ef3e2a"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg4"
            d="M26.576,9.095a12.278,12.278,0,0,1,1.345,4.541"
            fill="none"
            stroke="#c21f32"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg3"
            d="M23.694,5.337a12.278,12.278,0,0,1,2.883,3.757"
            fill="none"
            stroke="#269b47"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg2"
            d="M19.656,2.863a12.278,12.278,0,0,1,4.038,2.474"
            fill="none"
            stroke="#d19e28"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            id="sdg1"
            d="M15,2a12.278,12.278,0,0,1,4.656.863"
            fill="none"
            stroke="#eb1c2b"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
        </symbol>

        <svg id="icon-key-impact-global" viewBox="0 0 42 42">
          <path d="M2 15.2h5.1v11.9a1.7 1.7 0 01-1.7 1.7H2z" fill="#2b77a6" />
          <circle cx="4.55" cy="26.25" r="1" fill="#6dc3e5" />
          <path
            d="M9.1 15.2h1.7l2.9-2.9a1.7 1.7 0 011.2-.5h4.46L15 15.78a3.82 3.82 0 005.17 5.64l1.6-1.47 7.93 6.44a1.7 1.7 0 01.24 2.4l-.5.63a1.7 1.7 0 01-2.39.24l-.29-.23-1.67 2.04a1.97 1.97 0 01-2.78.3l-.95-.83h-.01a3.4 3.4 0 01-4.78.5l-4.81-4.35H9.1z"
            fill="#2b77a6"
          />
          <path
            d="M32.9 26.78l-9.86-8 1.39-1.26a.85.85 0 00-1.15-1.26l-4.25 3.9h-.02a2.21 2.21 0 01-2.98-.14 2.11 2.11 0 01.11-2.97l.02-.03 5.22-4.78a1.7 1.7 0 011.15-.44h4.56a1.68 1.68 0 011.2.5l2.9 2.9h1.7z"
            fill="#2b77a6"
          />
          <path
            d="M40 15.2v13.6h-3.4a1.7 1.7 0 01-1.7-1.7V15.2z"
            fill="#2b77a6"
          />
          <circle cx="37.45" cy="26.25" r="1" fill="#6dc3e5" />
        </svg>
      </defs>
    </svg>
  );
};

export default SpriteSvg;
